var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/arrow_back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.52083 10.8333L10.6042 14.9167C10.7708 15.0833 10.8507 15.2778 10.8438 15.5C10.8368 15.7222 10.75 15.9167 10.5833 16.0833C10.4167 16.2361 10.2222 16.316 10 16.3229C9.77778 16.3299 9.58333 16.25 9.41667 16.0833L3.91667 10.5833C3.83333 10.5 3.77431 10.4097 3.73958 10.3125C3.70486 10.2153 3.6875 10.1111 3.6875 10C3.6875 9.88889 3.70486 9.78472 3.73958 9.6875C3.77431 9.59028 3.83333 9.5 3.91667 9.41667L9.41667 3.91667C9.56944 3.76389 9.76042 3.6875 9.98958 3.6875C10.2188 3.6875 10.4167 3.76389 10.5833 3.91667C10.75 4.08333 10.8333 4.28125 10.8333 4.51042C10.8333 4.73958 10.75 4.9375 10.5833 5.10417L6.52083 9.16667H15.8333C16.0694 9.16667 16.2674 9.24653 16.4271 9.40625C16.5868 9.56597 16.6667 9.76389 16.6667 10C16.6667 10.2361 16.5868 10.434 16.4271 10.5938C16.2674 10.7535 16.0694 10.8333 15.8333 10.8333H6.52083Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.921e265bc7e692a29c815926bad20089.svg";
export { ForwardRef as ReactComponent };